export const MY_AGENTS_URL = '/api/officeservice/v1/me/office-allocations';
export const MY_PARTNER_AGENTS_URL = '/api/officeservice/v1/me/office-allocations/{officeAllocationId}/cooperating-allocations';
export const TENANT_INFO_URL = '/api/tenantservice/v1/tenant-info';
export const LEAD_SOURCES_URL = '/api/leadsourceservice/public/v1/lead-sources';
export const EMPLOYEE_INVITATIONS_URL = '/api/employeeservice/v1/users/{userId}/employee-invitations/';
export const TENANTS_URL = '/api/tenantservice/v1/tenants';
export const MY_APP_CONFIGS_URL = '/api/appservice/v1/me/app-configs';
export const MY_SENT_LEADS = '/api/p-agentservice/v1/me/sent-leads';
